import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import TermsDialog from '../../molecules/TermsDialog';
import { withRouter } from 'react-router-dom';

const TYPES = ['privacy-qr'];

/**
 * Description
 *
 * @typedef {Object} Props
 *
 * @augments {Component<Props>}
 */
class TermsDialogsView extends Component {

	getType = (pathname) => TYPES.find((type) => pathname.includes(type));

	handleClose = (type, pathname) => () => {
		this.props.history.push(pathname.replace(`/${type}`, ''));
	}

	render () {
		const { pathname } = this.props.location;
		const type = this.getType(pathname);
		let content = '';
		let handleClose = () => { };
		if (type) {
			content = this.props.content.terms[type];
			handleClose = this.handleClose(type, pathname);
		}

		return (
			<TermsDialog visible={true} onClose={handleClose}>
				{content}
			</TermsDialog>
		);
	}
}

export default withLanguageContext(withRouter(TermsDialogsView));



// WEBPACK FOOTER //
// ./src/components/views/TermsDialogView/TermsDialogView.js